import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { CONTACT_JEOPARDY } from '@/constants/urls.const';
import { ENTRA_SCOPES } from '@/constants/auth.const';
import { useMsal } from '@/composables/useMsal';
import { onMounted } from 'vue';
import { useRouter } from 'vue-router';
import FullScreenSpinner from '../FullScreenSpinner/FullScreenSpinner.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'LoginRedirect',
  setup(__props) {

const router = useRouter();
const { instance } = useMsal();
onMounted(async () => {
  await router.isReady();
  await instance.loginRedirect({
    scopes: [...ENTRA_SCOPES],
    state: router.currentRoute.value.query?.redirect_url?.toString() ?? CONTACT_JEOPARDY,
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(FullScreenSpinner))
}
}

})